<template>
  <div>
    <ThemePack :url="url" cur-class="theme_pack2" />
  </div>
</template>

<script>
import ThemePack from '@/views/config/activity-auxiliary/themePack.vue'
export default {
  name: 'ThemePack2',
  components: {
    ThemePack
  },
  data() {
    return {
      url: '/config/activity-auxiliary/theme_pack2'
    }
  }
}
</script>

<style scoped>

</style>
